import { FC } from 'react';

import EquityMarketAdminPanelConfigurationOfferConditions from './EquityMarketAdminPanelConfigurationOfferConditions';
import EquityMarketAdminPanelConfigurationSharePurchaseContract from './EquityMarketAdminPanelConfigurationSharePurchaseContract';
import EquityMarketAdminPanelPartnerAccess from './EquityMarketAdminPanelPartnerAccess';

type EquityMarketAdminPanelConfigurationProps = {
  societyId: string;
  onTogglePartnerAccess: (partnerIds: string[], enabled: boolean) => void;
  isLoading?: boolean;
};

const EquityMarketAdminPanelConfiguration: FC<
  EquityMarketAdminPanelConfigurationProps
> = ({ societyId, onTogglePartnerAccess, isLoading = false }) => (
  <>
    <EquityMarketAdminPanelConfigurationOfferConditions societyId={societyId} />
    <EquityMarketAdminPanelConfigurationSharePurchaseContract
      societyId={societyId}
    />
    <EquityMarketAdminPanelPartnerAccess
      societyId={societyId}
      onTogglePartnerAccess={onTogglePartnerAccess}
      isLoading={isLoading}
    />
  </>
);

export default EquityMarketAdminPanelConfiguration;
